/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : HeaderBanner.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Header Banner component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 26, 2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { HEADING_TEXT } from "./constants";
import "./HeaderBanner.scss";

export const HeaderBanner: FC = () => (
  <div className="header-banner">
    <h5>{HEADING_TEXT.heading1}</h5>
    <h1>{HEADING_TEXT.heading2}</h1>
  </div>
);
